module.exports = __webpack_public_path__ + "media/_/_/node_modules/gateway_web_console/app/assets/images/login-bg-mobile-b69fd4ff120a47c39281f4a9e654c4c7.jpg";